// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__jfbbN","meals-appear":"AvailableMeals_meals-appear__jnEyJ","loading":"AvailableMeals_loading__qPkQE"};